import { NotificationMessage } from '@carespace-icons/alerts/notificationMessage';
import { Image03 } from '@carespace-icons/files/image03';
import { VideoRecorder } from '@carespace-icons/media/videoRecorder';
import { useTypedDispatch, useTypedSelector } from '@stores/index';
import {
	IActivityStreamPanel,
	IActivitySTreamPostMedia,
	IProgramExercise,
} from '@stores/interfaces';
import {
	Avatar,
	Button,
	Col,
	Collapse,
	Image,
	Row,
} from 'antd';
import { Key, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {  MdOutlineRemoveRedEye } from 'react-icons/md';
import { ProgramSession } from '@atoms/AProgramSession';
import { SurveySession } from '@atoms/ASurveySession';
import StartSurvey from '@atoms/AStartSurvey/StartSurvey';
import { AEvaluation } from '../../../atoms/AEvaluation/AEvaluation';
import AProgram from '../../../atoms/AProgram/AProgram';
import { selectExercise } from '@stores/aiAssistant/program';
import { useNavigate } from 'react-router-dom';
import './style.css';
import { PlayCircle } from '@carespace-icons/media/playCircle';
import { setActiveTab } from '@stores/aiAssistant/aiAssistant';
import ActivityReport from '../ActivityReport/ActivityReport';
import { getRomSessionByIdforActivity, setSelectedRom } from '@stores/rom/customRom';
import { router } from '@routers/routers';
import { useTheme } from '@pages/Themes/ThemeContext';
import { URL_PATH } from '@stores/constants';

function ActivityStreamPanel(props: IActivityStreamPanel) {
	const {
		item,
		index,
		scrollEnabled,
		evaluationData,
		lastMessageRef,
		handleScrollTo,
	} = props;
	const {theme} = useTheme()
	const { Panel } = Collapse;
	const user = useTypedSelector(state => state.user);
	const selectedUser = useTypedSelector(
		state => state.contacts.main.selectedUser,
	);
	const { t } = useTranslation();
	const [exercises, setExercises] = useState<IProgramExercise[]>([]);
	const [programName, setProgramName] = useState('');
	const [programStatus, setProgramStatus] = useState<boolean>();
	const navigate = useNavigate();
	const dispatch = useTypedDispatch();
	const startProgramSession = () => {
		dispatch(selectExercise(exercises));
		navigate(
			`/${user?.isPhysioterapist ? selectedUser?.id : user?.id}${router.AIASSISTANT_PROGRAM_START}`,
		);
		dispatch(setActiveTab(''));
	};
	const [activeKey, setActiveKey] = useState<string[]>([]);
	
	const fetchRomSessionData = async (romId: string) => {
		const action = await dispatch(getRomSessionByIdforActivity({ customRomId: romId }));
		if (action?.payload) {
			dispatch(setSelectedRom(action?.payload));
			navigate(
				`/${user.isPhysioterapist ? selectedUser.id : user.id}/${URL_PATH.ROM}/${romId}/${URL_PATH.SCAN_RESULT}`,
			);
		}
	};

	const handlePanelChange = (key: string | string[]) => {
		setActiveKey(key instanceof Array ? key : [key]);
	};

	useEffect(() => {
		if (item.value) {
			setActiveKey([item.data.id]);
		}
	}, [item]);

	useEffect(() => {
		if (lastMessageRef.current && scrollEnabled) {
			lastMessageRef.current.scrollIntoView({ behavior: 'auto' });
		}
	}, [handlePanelChange]);

	const buttonStyle = {
		color: 'var(--button-text-color)',
		border: 'inherit',
	};

	return (
		<Collapse
			bordered={false}
			{...(item?.data?.activityStream?.romSessionId
				? { expandIcon: () => null }
				: {})}	
			style={{ width: '80%' }}
			className={`pt-panel as-panel stream-panel ${user.isPhysioterapist ? (item.data.physioterapistId ? 'margin-auto' : 'margin-left') : item.data.physioterapistId ? 'margin-left' : 'margin-auto'} bg-white-custom`}
			activeKey={activeKey}
			onChange={key => {
				if (!item?.data?.activityStream?.romSessionId) {
					handlePanelChange(key);
				}
			}}>
			<>
				<Panel
					key={item.data.id}
					className={`header-panel panel  ${item.title !== '' && item.subtitle !== '' ? 'bg-white-custom ' : 'bg-slate-custom'}`}
					ref={index === evaluationData.length - 1 ? lastMessageRef : null}
					header={
						<div className="panel-head"
						onClick={e => {
							if(item?.data?.activityStream?.romSessionId) {
							  	e.stopPropagation();
									fetchRomSessionData(item?.data?.activityStream?.romSessionId);
							}
						}}>
							<div className="panel-profile">
								<>
									{selectedUser?.profile?.imageUrl ||
										user?.profile?.imageUrl ? (
										<Avatar
											src={
												user?.isPhysioterapist
													? selectedUser?.profile?.imageUrl
													: user?.profile?.imageUrl
											}
											alt="avatar"
											size={30}
										/>
									) : (
										<Avatar
											style={{
												backgroundColor: user?.isPhysioterapist
													? selectedUser?.profile?.avatarColor
													: user?.profile?.avatarColor
											}}
											className="custom-inline-flex-panel"
											alt="avatar"
											size={32}>
											{user?.isPhysioterapist
												? selectedUser?.profile?.firstName
													?.charAt(0)
													?.toUpperCase()
												: user?.profile?.firstName?.charAt(0)?.toUpperCase()}
										</Avatar>
									)}
								</>
							</div>
							{item.title != '' && item.subtitle != '' ? (
								<div className="panel-item">
											{item && (
												<>
													<div className='flex-items-center' style={{ justifyContent: "space-between" }}>
														<div className="custom-panel-details">
															<div className="custom-panel-column-item">
																<h3 className="custom-font-bold">{item.title}</h3>
																<p>{item.subtitle}</p>
															</div>
														</div>
														<ActivityReport item={item} />
													</div>
												</>
											)}
								</div>
							) : (
								<div className="custom-flex-grow">
									<div className="flex-items-center">
										{!item?.data?.physioterapistId && (
											<div className="flex-items-center-justify-center custom-image-div">
												<div className="custom-icon-div flex-items-center-justify-center">
													{item?.data?.activityStreamPost
														?.activityStreamPostMedia &&
														item.data.activityStreamPost
															.activityStreamPostMedia[0]?.image ? (
														<Image03
															width={20}
															height={20}
															color="stroke-gray-600"
														/>
													) : item?.data?.activityStreamPost
														?.activityStreamPostMedia &&
														item.data.activityStreamPost
															.activityStreamPostMedia[0]?.video ? (
														<VideoRecorder
															width={20}
															height={20}
															color="stroke-gray-600"
														/>
													) : (
														<NotificationMessage
															width={20}
															height={20}
															color="stroke-gray-600"
														/>
													)}
												</div>
											</div>
										)}
										<div className="panel-item">
											{item?.data?.physioterapistId &&
												!item?.data?.activityStream?.surveyId &&
												!item?.data?.activityStream?.programId ? (
												<>
													<h3 className="custom-font-bold">
														{t('Admin.data.inbox.feedback')}
													</h3>
													<p>
														{t('Admin.data.inbox.hello')}{' '}
														{user.isPhysioterapist
															? selectedUser?.profile?.fullName
															: user?.profile?.fullName}
														, {t('Admin.data.inbox.instruction')}{' '}
													</p>
												</>
											) : (
												<>
													{item?.data?.activityStreamPost
														?.activityStreamPostMedia &&
														item.data.activityStreamPost
															.activityStreamPostMedia[0]?.video ? (
														<h3 className="custom-font-bold">
															{t('Patient.data.activityStream.newVideoMsg')}
														</h3>
													) : item?.data?.activityStreamPost
														?.activityStreamPostMedia ||
														(item?.data?.activityStreamPost
															?.activityStreamPostMedia[0]?.image &&
															item?.data?.activityStreamPost?.message) ? (
														<h3 className="custom-font-bold">
															{t('Patient.data.activityStream.newMsg')}
														</h3>
													) : null}
												</>
											)}
											{item?.data?.physioterapistId &&
												item?.data?.activityStream?.surveyId && (
													<>
														<h3 className="custom-font-bold custom-mt-3">
															{t('Admin.data.survey.assignedSurvey')}
														</h3>
													</>
												)}
											{item?.data?.physioterapistId &&
												item?.data?.activityStream?.programId && (
													<>
														<div className="custom-flex-flex-row-items-center-justify-between">
															<div className="custom-flex-col">
																<h3 className="custom-font-bold">
																	{t('Patient.data.activityStream.newProgramAssigned')}
																</h3>
																{programName && (
																	<span className="custom-mx-1">
																		{programName}
																	</span>
																)}
															</div>
															{programStatus && (
																<div>
																	<Button
																		className="start-session-css"
																		style={buttonStyle}
																		icon={
																			<PlayCircle
																				height={12}
																				width={12}
																				color="var(--button-text-color)"
																			/>
																		}
																		onClick={e => {
																			e.stopPropagation();
																			startProgramSession();
																		}}>
																		{t(
																			'Patient.data.myProgress.rehab.startSession',
																		)}
																	</Button>
																</div>
															)}
														</div>
													</>
												)}
										</div>
									</div>
								</div>
							)}
						</div>
					}>
					{item?.data?.activityStream?.evaluationSessionId && (
						<AEvaluation
							evaluationId={item?.data?.activityStream?.evaluationSessionId}
						/>
					)}
					{item?.data?.activityStream?.programId && (
						<AProgram
							programId={item?.data?.activityStream?.programId}
							setProgramName={setProgramName}
							setProgramStatus={setProgramStatus}
							exercises={exercises}
							setExercises={setExercises}
						/>
					)}
					{item?.data?.activityStream?.programSessionId && (
						<ProgramSession id={item?.data?.activityStream?.programSessionId} />
					)}
					{item?.data?.activityStream?.surveyResultId && (
						<SurveySession id={item?.data?.activityStream?.surveyResultId} />
					)}
					{item?.data?.physioterapistId &&
						item?.data?.activityStream?.surveyId && (
							<>
								<StartSurvey id={item?.data?.activityStream?.surveyId} />
							</>
						)}
					{item?.data?.activityStreamPost ? (
						<>
							{evaluationData.map(evaluationItem => {
								if (
									evaluationItem.data.activityStreamId &&
									evaluationItem.data.activityStreamId ===
									item?.data?.activityStreamPost?.activityStreamId
								) {
									return (
										<div
											className="activity-padding"
											key={index}
											onClick={() =>
												handleScrollTo(evaluationItem.data.activityStreamId)
											}>
											<div
												className="activity-item"
												style={{ background: 'var(--activity-stream-message-color)' }}>
												<div className="activity-header">
													<div
														className="colored-bar"
														style={{ background: 'var(--onboard-button-color)' }}>
														&nbsp;
													</div>
													<img
														src={
															user.isPhysioterapist
																? selectedUser?.profile?.imageUrl ||
																'/images/default-profile.png'
																: user?.profile?.imageUrl ||
																'/images/default-profile.png'
														}
														onError={e => {
															(e.target as HTMLImageElement).src =
																'/images/default-profile.png';
														}}
														className="profile-image"
													/>
													<p className="custom-font-bold custom-text-gray-blue-500">
														{user.isPhysioterapist
															? selectedUser?.profile?.fullName
															: user?.profile?.fullName}
													</p>
												</div>
												<div className="custom-title">
													<div
														className="custom-space"
														style={{
															background: 'var(--onboard-button-color)',
															padding: '5px',
														}}>
														&nbsp;
													</div>
													<div className="custom-inner-title">
														<p className="custom-font-bold custom-text-gray-blue-500">
															{evaluationItem.title}
														</p>
														<p className="custom-text-gray-blue-500">
															{evaluationItem.subtitle}
														</p>
													</div>
												</div>
											</div>
										</div>
									);
								}
								return null;
							})}
							<div>
								{item?.data?.activityStreamPost?.activityStreamPostMedia.map(
									(
										postMedia: IActivitySTreamPostMedia,
										index: Key | null | undefined,
									) => (
										<div key={index} className="custom-padding">
											{postMedia?.image && (
												<Row gutter={[16, 16]} align="middle">
													<Col span={8}>
														<Image
															src={postMedia?.image}
															className="custom-image"
															height={140}
															preview={{
																src: postMedia?.image,
																mask: <MdOutlineRemoveRedEye size={18} />,
															}}
														/>
													</Col>
													<Col span={16} className="popup-message-head">
														<h3 className="popup-message">
															{item?.data?.activityStreamPost?.message}
														</h3>
													</Col>
												</Row>
											)}
											{postMedia?.video && (
												<Row gutter={[16, 16]} align="middle">
													<Col span={8}>
														<video
															src={postMedia?.video}
															controls
															className="custom-image"
															preload="metadata"
															width={250}
															height={140}
														/>
													</Col>
													<Col span={16} className="popup-message-head">
														<h3 className="popup-message">
															{item?.data?.activityStreamPost?.message}
														</h3>
													</Col>
												</Row>
											)}
										</div>
									),
								)}
							</div>
						</>
					) : null}
					{item?.data?.activityStreamPost?.activityStreamPostMedia?.length ===
						0 && item?.data?.activityStreamPost?.message ? (
						<h3 className="popup-message plain-message">
							{item?.data?.activityStreamPost?.message}
						</h3>
					) : null}
				</Panel>
			</>
		</Collapse>
	);
}

export default ActivityStreamPanel;
